import { Navigate, Outlet, useLocation } from 'react-router-dom';

export const StripTrailingSlashRedirect = () => {
    const location = useLocation();
    const { pathname, search, hash } = location;
  
    if (pathname !== "/" && pathname.endsWith("/")) {
      return (
        <Navigate
          to={pathname.slice(0, -1) + search + hash}
          replace
        />
      );
    }
  
    return <Outlet />;
  }